import { render, staticRenderFns } from "./uniq-offer-viewer.vue?vue&type=template&id=c8c17ecc&"
import script from "./uniq-offer-viewer.vue?vue&type=script&lang=ts&"
export * from "./uniq-offer-viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports